/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { Course } from '../../../types/course.type';
import { CourseCard, course_type_card_style_lookup } from './CourseCard';
import './CourseCard.css';

interface SelectedCourseProps {
  course?: Course;
  onClose: () => void;
}

const SelectedCourse: React.FC<SelectedCourseProps> = ({ course, onClose }) => {
  if (!course) return null;

  const color = course_type_card_style_lookup(course.course_type);

  return (
      <div className="course-search-selected-panel">
        <div className="small text-muted text-uppercase fw-semibold mb-2">Selected Session</div>
        <div className={`selected-course-card ${color}`}>
          <CourseCard
              course={course}
              selected={true}
              onClose={onClose}
          />
        </div>
      </div>
  );
};

export default SelectedCourse;
